import FeatureFlags from 'src/app/account/my-account/model/FeatureFlags.enum';

export class GpDetailsReqRes {
  public organizationDetailsId: number;
  public agentCompanyName: string;
  public email: string;
  public agentCompanyLogoUrl: string;
  public featureFlags: FeatureFlags;
}
